export default "__VITE_ASSET__Dbam7UX___"